import { Link } from 'react-router-dom';
import { currentUserStore } from '../../../../../../CurrentUserStore';
import { findLink } from '../../../../../../LinkyLinky';
import { T } from '../../../../../../Translations';
import { Maybe } from 'maybeasy';
import { Link as LinkT } from '../../../../../../Resource/Types';

export interface Props {
  id: number;
  links: ReadonlyArray<LinkT>;
}

export const editLink = ({ id, links }: Props): Maybe<React.ReactNode> =>
  // Check BOTH: user has global edit permission AND collection has edit-v1 link
  // The per-collection link is only present when the collection has a product_license
  findLink('edit-learning-collection-template', currentUserStore.links)
    .andThen(() => findLink('edit-learning-collection', links))
    .map(() => {
      // When v2 is also enabled for the user (org opted into show_builder_v1
      // during transition), disambiguate v1 as "Edit (classic)" so it sits
      // alongside the v2 link, which is labelled just "Edit".
      const v2Enabled = findLink(
        'edit-learning-collection-template-v2',
        currentUserStore.links,
      ).isJust();
      return (
        <Link
          key="edit-learning-collection-template"
          to={`/learning_collections/${id}/edit/describe`}
          className="px-4 py-2.5"
          data-intercom-target="edit-collection-action"
        >
          {v2Enabled ? <T kind="Edit (classic)" /> : <T kind="Edit" />}
        </Link>
      );
    });
